var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScootericonBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.55,
    height: 18.254,
    viewBox: "0 0 10.55 18.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Scooter_216872",
    transform: "translate(-22.65 -3.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4438",
    "data-name": "Caminho 4438",
    d: "M32.859,3.632H23.012a.575.575,0,0,0-.362.5v.377a.612.612,0,0,0,.362.517H27.1l.184,9.929a2.1,2.1,0,0,0-1.761,2.151v2.17a.508.508,0,0,0,.552.446H26.4a.508.508,0,0,0,.552-.446v-2.17h0a1.368,1.368,0,0,1,2.659,0h0v2.17a.508.508,0,0,0,.552.446h.328a.508.508,0,0,0,.552-.446v-2.17a2.24,2.24,0,0,0-1.929-2.151L28.93,5.032h3.931A.606.606,0,0,0,33.2,4.51V4.132a.567.567,0,0,0-.341-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4440",
    "data-name": "Caminho 4440",
    d: "M47.709,75.357h-.328a.552.552,0,0,0-.552.552v4.656a.552.552,0,0,0,.552.552h.328a.552.552,0,0,0,.552-.552V75.909a.552.552,0,0,0-.552-.552Z",
    transform: "translate(-19.272 -59.231)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScootericonBlack);
export default __webpack_public_path__ + "static/media/scootericon_black.0e8eed3e.svg";
export { ForwardRef as ReactComponent };